import styles from '../globals/pages.module.scss'
import pageStyles from './styles.module.scss'

import { useEffect, useState } from 'react'
import axios from 'axios'
import { useParams } from 'react-router-dom'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'

import { Wrapper } from '../components/reusable'
import CfaBanner from '../components/cfaBanner'
import SingleSignatureContainer from '../components/singleSigContainer'
import { apiErrors } from '../helpers/apiErrors'
import PocView from '../components/pocView'
import { useUpdateClaimData } from '../claimProvider'
import { browserName, osName, deviceDetect, getUA } from 'react-device-detect'
import LoaBanner from '../components/loaBanner'

export default function LoaOptions() {
    const [loaData, setLoaData] = useState([])
    const [retrievedCfa, setRetrievedCfa] = useState(false)
    const [currentClaim, setCurrentClaim]: any = useState({})
    const [selectedOption, setSelectedOption] = useState<string>('')
    const { token } = useParams()
    const updateClaim = useUpdateClaimData()
    useEffect(() => {
        if (!retrievedCfa) {
            Loading.standard('Loading...')
            axios
                .post(`${process.env.REACT_APP_API_TOKEN_URL}`, { token })
                .then((response) => {
                    const responseData = response.data
                    if (responseData == 'LOA Complete') {
                        Report.success('Document Signed', 'Your Document has already been signed.', 'Okay', () => {
                            window.location.href = 'https://sentinellegal.co.uk'
                        })
                    }

                    const signatureData = responseData.sigData
                    console.log(signatureData)

                    if (!signatureData) throw new Error(responseData)
                    localStorage.setItem('name', `${signatureData.first_name} ${signatureData.last_name}`)

                    setLoaData(signatureData)
                    setCurrentClaim(signatureData)
                    setRetrievedCfa(true)
                    updateClaim(signatureData)

                    Loading.remove()
                })
                .catch((e) => {
                    console.error('error:', e)
                    const serverError = e.response.data
                    Loading.remove()
                    apiErrors(serverError)
                })
        }
    }, [])

    const completeCfa = (obj: any) => {
        Report.success(
            'Letter of Authority Complete',
            'Thank you for signing your document. We will update you on your cases in due course.',
            'Okay',
            () => {
                window.location.href = 'https://sentinellegal.co.uk'
            }
        )

        return
    }

    return (
        <div className={`${styles.pageContent} ${styles.pocContent}`}>
            <LoaBanner />
            <Wrapper>
                <>
                    <h2>Post Supreme Court / FCA Announcement Instructions</h2>
                    <p>
                        Please select an option below to confirm your instructions on how you wish for us to proceed
                        with your claim.
                    </p>
                    <form>
                        <div style={{ marginBottom: '30px' }}>
                            <p
                                style={{
                                    marginBottom: '20px',
                                    fontWeight: 'bold',
                                    fontSize: '17px',
                                    color: '#333',
                                }}
                            >
                                Please select an option:
                            </p>
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '15px',
                                    alignItems: 'flex-start',
                                }}
                            >
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        width: '100%',
                                    }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => setSelectedOption('option1')}
                                        style={{
                                            padding: '12px 24px',
                                            backgroundColor: selectedOption === 'option1' ? '#C78E5F' : 'whitesmoke',
                                            color: selectedOption === 'option1' ? 'white' : '#C78E5F',
                                            border:
                                                selectedOption === 'option1'
                                                    ? '1px solid #C78E5F'
                                                    : '1px solid #C78E5F',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            fontFamily: 'Poppins, sans-serif',
                                            transition: 'all 0.3s ease',
                                            minWidth: '120px',
                                            letterSpacing: '0.5px',
                                        }}
                                        onMouseEnter={(e) => {
                                            if (selectedOption !== 'option1') {
                                                e.currentTarget.style.backgroundColor = '#C78E5F'
                                                e.currentTarget.style.color = 'white'
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (selectedOption !== 'option1') {
                                                e.currentTarget.style.backgroundColor = 'whitesmoke'
                                                e.currentTarget.style.color = '#C78E5F'
                                            }
                                        }}
                                    >
                                        Option 1
                                    </button>
                                    <span
                                        style={{
                                            fontSize: '15px',
                                            color: '#333',
                                            fontWeight: '400',
                                        }}
                                    >
                                        Continue with Sentinel Legal and request the court to lift any pause on my claim
                                        and provide directions to a final hearing.
                                    </span>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        width: '100%',
                                    }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => setSelectedOption('option2')}
                                        style={{
                                            padding: '12px 24px',
                                            backgroundColor: selectedOption === 'option2' ? '#C78E5F' : 'whitesmoke',
                                            color: selectedOption === 'option2' ? 'white' : '#C78E5F',
                                            border:
                                                selectedOption === 'option2'
                                                    ? '1px solid #C78E5F'
                                                    : '1px solid #C78E5F',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            fontFamily: 'Poppins, sans-serif',
                                            transition: 'all 0.3s ease',
                                            minWidth: '120px',
                                            letterSpacing: '0.5px',
                                        }}
                                        onMouseEnter={(e) => {
                                            if (selectedOption !== 'option2') {
                                                e.currentTarget.style.backgroundColor = '#C78E5F'
                                                e.currentTarget.style.color = 'white'
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (selectedOption !== 'option2') {
                                                e.currentTarget.style.backgroundColor = 'whitesmoke'
                                                e.currentTarget.style.color = '#C78E5F'
                                            }
                                        }}
                                    >
                                        Option 2
                                    </button>
                                    <span
                                        style={{
                                            fontSize: '15px',
                                            color: '#333',
                                            fontWeight: '400',
                                        }}
                                    >
                                        Await the FCA Redress Scheme.
                                    </span>
                                </div>
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '15px',
                                        width: '100%',
                                    }}
                                >
                                    <button
                                        type="button"
                                        onClick={() => setSelectedOption('option3')}
                                        style={{
                                            padding: '12px 24px',
                                            backgroundColor: selectedOption === 'option3' ? '#C78E5F' : 'whitesmoke',
                                            color: selectedOption === 'option3' ? 'white' : '#C78E5F',
                                            border:
                                                selectedOption === 'option3'
                                                    ? '1px solid #C78E5F'
                                                    : '1px solid #C78E5F',
                                            borderRadius: '5px',
                                            cursor: 'pointer',
                                            fontSize: '15px',
                                            fontWeight: '600',
                                            fontFamily: 'Poppins, sans-serif',
                                            transition: 'all 0.3s ease',
                                            minWidth: '120px',
                                            letterSpacing: '0.5px',
                                        }}
                                        onMouseEnter={(e) => {
                                            if (selectedOption !== 'option3') {
                                                e.currentTarget.style.backgroundColor = '#C78E5F'
                                                e.currentTarget.style.color = 'white'
                                            }
                                        }}
                                        onMouseLeave={(e) => {
                                            if (selectedOption !== 'option3') {
                                                e.currentTarget.style.backgroundColor = 'whitesmoke'
                                                e.currentTarget.style.color = '#C78E5F'
                                            }
                                        }}
                                    >
                                        Option 3
                                    </button>
                                    <span
                                        style={{
                                            fontSize: '15px',
                                            color: '#333',
                                            fontWeight: '400',
                                        }}
                                    >
                                        Cancel my claim with Sentinel and pay any fees incurred as per my agreement.
                                    </span>
                                </div>
                            </div>
                            {selectedOption && (
                                <p
                                    style={{
                                        marginTop: '15px',
                                        color: '#C78E5F',
                                        fontSize: '15px',
                                        fontWeight: '500',
                                    }}
                                >
                                    Selected: {selectedOption}
                                </p>
                            )}
                        </div>
                    </form>
                    <hr />
                    <PocView>
                        {retrievedCfa ? (
                            <SingleSignatureContainer
                                signedAction={completeCfa}
                                previewUrl={currentClaim.doc_url}
                                extraPayload={{
                                    type: 'loa-options',
                                    metadata: { browser: browserName, device: osName },
                                    clientSelection: selectedOption,
                                }}
                            />
                        ) : (
                            <></>
                        )}
                    </PocView>
                </>
            </Wrapper>
        </div>
    )
}
